module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7dXqQ"))).then(() => parcelRequire('d0iPb'));